import { combineReducers } from '@reduxjs/toolkit'
import deviceListReducer from './deviceListSlice'

const yingshiStore = combineReducers({
  deviceList: deviceListReducer
})

export default yingshiStore
